"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COVERAGE_TYPE = exports.ENDORSEMENT_TYPE = void 0;
exports.ENDORSEMENT_TYPE = 'E';
exports.COVERAGE_TYPE = 'C';
//# sourceMappingURL=coverageTypes.js.map